import { useFitFinderToggle } from '@components/FitFinder/hooks/useFitFinderToggle'
import { ButtonLink } from '@components/ui/Button'
import htmr from 'htmr'
import { Button, HeroBannerItemProps } from '.'
import classNames from 'classnames'
import styles from './styles.module.scss'
import Badge from '@components/ui/Badge'

const formatText = (text = ''): React.ReactNode =>
  htmr(text.replace(/\\n/g, '<br>'))

export function HeroBannerTextContent({
  badge,
  backgroundMode,
  title,
  subtitle,
  button,
  secondaryButton,
  whitebackground,
  mobileGradient,
  horizontalMobileDown,
  horizontalTabletDown,
  horizontalDesktopUp,
  verticalMobileDown,
  verticalTabletDown,
  verticalDesktopUp,
  sendEvent
}: HeroBannerItemProps) {
  const { openFitFinder } = useFitFinderToggle()

  const handleClick = (
    ev: React.MouseEvent<HTMLAnchorElement>,
    clickedButton: Button
  ) => {
    if (ev.currentTarget.pathname.includes('/pages/fit-finder')) {
      ev.preventDefault()
      openFitFinder()
    }
    sendEvent(clickedButton.event)
  }

  const isButtonOnly = !title && !subtitle && !!button
  const topOffSet =
    verticalMobileDown === 'start' ||
    verticalTabletDown === 'start' ||
    verticalDesktopUp === 'start'

  return (
    <div
      className={classNames(
        styles.bannerItem__content,
        `horizontal-${horizontalTabletDown}-tablet-only`,
        `horizontal-${horizontalMobileDown}-mobile-down`,
        `horizontal-${horizontalDesktopUp}-desktop-up`,
        `vertical-${verticalTabletDown}-tablet-only`,
        `vertical-${verticalMobileDown}-mobile-down`,
        `vertical-${verticalDesktopUp}-desktop-up`,
        {
          [styles.bannerItem__content_gradient]: mobileGradient,
          [styles.buttonOnly]: isButtonOnly
        }
      )}
    >
      <div
        className={classNames(styles.bannerItem__container, {
          [styles.bannerItem__title_largeMargin]: topOffSet
        })}
      >
        {badge && (
          <div className={styles.bannerItem__badge}>
            <Badge {...badge} />
          </div>
        )}
        {title && (
          <h1
            className={classNames(
              styles.bannerItem__title,
              `bannerItem__title--${backgroundMode}`
            )}
          >
            {formatText(title)}
          </h1>
        )}
        {subtitle && (
          <h3
            className={classNames(
              styles.bannerItem__subtitle,
              `bannerItem__subtitle--${backgroundMode}`
            )}
          >
            {formatText(subtitle)}
          </h3>
        )}
        {(button?.uri || secondaryButton?.uri) && (
          <div className={styles.bannerItem__buttonsWrapper}>
            {button?.uri && (
              <div className={styles.bannerItem__button}>
                <ButtonLink
                  className={button.classes}
                  variant={button.buttonStyle || 'primary'}
                  href={button.uri}
                  onClick={ev => handleClick(ev, button)}
                  fullWidth="inherit"
                >
                  {button.text}
                </ButtonLink>
              </div>
            )}
            {secondaryButton?.uri && (
              <ButtonLink
                className={styles.bannerItem__button}
                variant={whitebackground ? 'secondary' : 'white_outline'}
                href={secondaryButton.uri}
                onClick={ev => handleClick(ev, secondaryButton)}
                fullWidth="inherit"
              >
                {secondaryButton.text}
              </ButtonLink>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
